import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, input, OnInit, Output } from '@angular/core';
import { Button } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { EnumToStringPipe } from '@app/features-modules/gestao-bolseiros/pipes/enum-to-string.pipe';
import { InstituicaoGestora } from '../../api/models/instituicao-gestora.model';
import { AvatarModule } from 'primeng/avatar';
import { getInitials } from '@shared/pipes/initials.pipe';

@Component({
  selector: 'app-maisdetalhes-instituicoes-gestoras',
  imports: [CommonModule, Button, TableModule, TagModule, EnumToStringPipe, AvatarModule],
  templateUrl: './maisdetalhes-instituicoes-gestoras.component.html',
  styleUrl: './maisdetalhes-instituicoes-gestoras.component.scss'
})
export class MaisdetalhesInstituicoesGestorasComponent implements OnInit {
  imageError = false;

  getInitials(name?: string | null): string {
    return getInitials(name);
  }

  @Output() onCloseModal = new EventEmitter<boolean>();

  instituicao = input<InstituicaoGestora>()

  ngOnInit(): void {
    
  }

  closeModal() {
    this.onCloseModal.emit(true)
  }

}
